export const useAcceptSubmissionRoughDraftInAnyFormat = (
  submission: SubmittedDocument
) => {
  if (submission.assignmentRequireRoughDraftChecklist == true) {
    return false;
  }

  const kwoFormats = useKWOFileTypes();

  const roughDraftSubmissionFormats =
    submission.assignmentRoughDraftSubmissionFormats ?? [];
  // If any kwo format is not in the rough draft submission formats, return false
  for (const format of kwoFormats) {
    if (roughDraftSubmissionFormats?.includes(format) != true) {
      return false;
    }
  }

  return true;
};
